import {useQuery} from 'react-query';
import {getRequirementView} from '.';

interface IUseGetRequirementViewProps {
  guid?: string;
  requirement_type: string;
}
const useGetRequirementView = ({
  guid,
  requirement_type,
}: IUseGetRequirementViewProps) => {
  const {data, isLoading} = useQuery({
    queryKey: ['RequirementViewDetail', guid],
    queryFn: () => getRequirementView({guid, requirement_type}),
    enabled: guid ? true : false,
  });
  return {RequirementViewData: data, RequirementViewIsLoading: isLoading};
};

export default useGetRequirementView;
